import { useContext, useEffect, useState } from 'react';
import { apis } from '../services/alm';
import { Tag } from '../assets/constants/constants';
import { AppContext } from '../context/AppProvider';

const useVideoTutorialHook = () => {
  const [videoTutorialCatalogId, setvideoTutorialCatalogId] = useState<any>();
  const [isVideoTutorialData, setIsVideoTutorialData] = useState<any>([]);
  const [isLoading, setisLoading] = useState<any>(false);

  const { state } = useContext(AppContext);
  const catalogIds = async () => {
      const videoCatId = state?.catlogList.filter((res: any) => {
        return res?.attributes?.name == Tag.videoTutorial;
      })[0]?.id
      if (videoCatId) {
        setvideoTutorialCatalogId(videoCatId);
      }
    } 
  const videoTutorialData = async () => {
    const response: any = await apis.fetchContentByCatalogIdForLibrary(videoTutorialCatalogId);
    setIsVideoTutorialData(response?.data);
    setisLoading(true)
  };
  useEffect(() => {
    if(state?.catlogList){
      catalogIds();
    }
  }, [state?.catlogList]);

  useEffect(() => {
    if (videoTutorialCatalogId) {
      videoTutorialData();
    } 
  }, [videoTutorialCatalogId]);
  return {
    isVideoTutorialData,
    isLoading
  };
};

export default useVideoTutorialHook;
